/**
 * Cart Animation Handler
 * Triggers shake and bounce animations on cart icon when items are added
 * Shows "Adding..." text on button during add to cart
 */

(function() {
  'use strict';

  let dotIntervals = new Map(); // Store intervals per button

  // Listen for cart:item-added custom event
  document.addEventListener('cart:item-added', function() {
    animateCart();
    resetAllButtons();
  });

  // Also listen for any cart update events
  document.addEventListener('cart:updated', function() {
    animateCart();
  });

  function animateCart() {
    // Find cart icon elements
    const cartIcon = document.querySelector('[data-js-cart-icon]');
    const cartCount = document.querySelector('[data-js-cart-count]');

    if (cartIcon) {
      // Remove animation class if it exists (to restart animation)
      cartIcon.classList.remove('cart-icon--animate');

      // Force reflow to restart animation
      void cartIcon.offsetWidth;

      // Add animation class
      cartIcon.classList.add('cart-icon--animate');

      // Remove animation class after animation completes
      setTimeout(() => {
        cartIcon.classList.remove('cart-icon--animate');
      }, 500);
    }

    if (cartCount) {
      // Animate cart count badge
      cartCount.classList.remove('cart-count--animate');
      void cartCount.offsetWidth;
      cartCount.classList.add('cart-count--animate');

      setTimeout(() => {
        cartCount.classList.remove('cart-count--animate');
      }, 400);
    }
  }

  function showAddingText(button) {
    const textElement = button.querySelector('[data-add-to-cart-text]');
    if (!textElement) return;

    // Store original text if not already stored
    if (!button.dataset.originalText) {
      button.dataset.originalText = textElement.textContent.trim();
    }

    let dots = 0;

    // Change text to "Adding"
    textElement.textContent = 'Adding';

    // Clear any existing interval for this button
    if (dotIntervals.has(button)) {
      clearInterval(dotIntervals.get(button));
    }

    // Animate dots
    const interval = setInterval(() => {
      dots = (dots + 1) % 4;
      textElement.textContent = 'Adding' + '.'.repeat(dots);
    }, 300);

    dotIntervals.set(button, interval);
  }

  function hideAddingText(button) {
    // Clear interval for this button
    if (dotIntervals.has(button)) {
      clearInterval(dotIntervals.get(button));
      dotIntervals.delete(button);
    }

    const textElement = button.querySelector('[data-add-to-cart-text]');
    if (textElement && button.dataset.originalText) {
      textElement.textContent = button.dataset.originalText;
      delete button.dataset.originalText;
    }
  }

  function resetAllButtons() {
    const buttons = document.querySelectorAll('[data-add-to-cart]');
    buttons.forEach(button => {
      hideAddingText(button);
    });
  }

  // Watch for loading class being added/removed
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const button = mutation.target;
        if (button.classList.contains('loading')) {
          showAddingText(button);
        } else {
          // When loading class is removed, reset the button
          hideAddingText(button);
        }
      }
    });
  });

  // Observe all add to cart buttons
  function observeButtons() {
    const buttons = document.querySelectorAll('[data-add-to-cart]');
    buttons.forEach(button => {
      observer.observe(button, { attributes: true });
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeButtons);
  } else {
    observeButtons();
  }

  // Re-observe buttons after a delay (in case new ones are added dynamically)
  setTimeout(observeButtons, 1000);

})();
